import { MutableRefObject, ReactNode, RefObject } from "react";
import './modal.css'

export default function Modal(props:{modalRef?: RefObject<HTMLDivElement>,children: ReactNode, on_click_background?: ()=>void}){  
    return  <div 
        ref={props.modalRef}
        className="modal" 
        role="dialog" 
        aria-modal="true" 
        aria-labelledby="modal-title"
        // aria-describedby="modal-description"
        tabIndex={-1}
        onKeyUp={(event)=>{
           if (!props.on_click_background || event.code != "Escape") { return } 
           props.on_click_background();
        }}
    >
        <div onClick={()=>{if(props.on_click_background){
            props.on_click_background();
        }}} 
        className="modal__background"
        aria-hidden
        ></div>
        {props.children}
    </div>;  
}    

  //useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === 'Escape') {
//         pop_modal();
//       }
//     };

//     document.addEventListener('keydown', handleKeyDown);
    
//     return () => {
//       document.removeEventListener('keydown', handleKeyDown);
//     };
//   }, []);